import styled from 'styled-components';

export const Button = styled.button`
  &.current {
    background-color: ${(props) => props.theme.$info};
    color: ${(props) => props.theme.$white};
  }

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;
